import _ from 'lodash'
import { FunctionField, RaRecord } from 'react-admin'
import { NameFieldProps } from './type'

export const NameField: React.FC<NameFieldProps> = ({
  firstNameSource,
  lastNameSource = '',
  ...props
}) => {
  const render = (record: RaRecord): string => {
    if (!record) return null
    const firstName = _.get(record, firstNameSource, '')
    const lastName = _.get(record, lastNameSource, '')
    return `${firstName}${lastName ? ' ' + lastName : ''}`
  }

  const { sx, textAlign } = props
  const defaultSx = {
    display: 'block',
    textAlign,
    ...sx,
  }

  return <FunctionField render={render} {...props} sx={defaultSx} />
}
